module.exports = __webpack_public_path__ + "static/media/mercedesvideo1.006f49aa.mp4";